// extracted by mini-css-extract-plugin
export var buttons = "_3e-0";
export var buttonsActive = "_3e-h";
export var cancelConfirm = "_3e-1";
export var closeButton = "_3e-2";
export var column = "_3e-3";
export var container = "_3e-4";
export var detailHeader = "_3e-6";
export var detailTitle = "_3e-7";
export var detailsContent = "_3e-5";
export var header = "_3e-8";
export var headerWithClose = "_3e-9";
export var icon = "_3e-a";
export var infoIcon = "_3e-c";
export var informationContainer = "_3e-b";
export var sideDrawer = "_3e-d";
export var sideDrawerOpen = "_3e-e";
export var stickyFooter = "_3e-f";
export var typeOption = "_3e-g";